module.exports = __webpack_public_path__ + "static/media/tj.1793caa0.svg";